/*
 * ProvAJAX
 *
 * 1.1 - Added support for in-place loading of HTML
 * 1.0 - Initial Version
 */
 

provajax={
	
	//--------------------------------------------------------------------------------
	//Public code
	//--------------------------------------------------------------------------------
	
	ajaxParams: function(httplistenerurl, errorFunction, successFunction, passThrough, callFunctionName) //, params
	{ 
		var _BASICARGS = 5;
		if (arguments.length < _BASICARGS)	//Check for basic parameters
			throw ("Wrong number of parameters to ajax function");
		if ((arguments.length - _BASICARGS) % 2 != 0) //Check to make sure function params are in name/value pairs
			throw ("Wrong number of parameters to ajaxParams function");			           
        
	  $.ajax({
    	url: httplistenerurl,
    	contentType: 'text/xml',
		async: false,
    	type: 'POST',
    	dataType: 'xml',
    	timeout: 30000,
    	data: this._xmlRequestParams(callFunctionName, arguments, _BASICARGS+1),
    	error: this._onError,
    	success: this._onSuccessParams,
    	mySuccess: successFunction,
    	myCallFunctionName: callFunctionName,
    	myErrorFunction: errorFunction,
    	myPassThrough: passThrough
		});
	},

	ajaxXml: function(httplistenerurl, errorFunction, successFunction, passThrough, inXml)
	{
		var _BASICARGS = 5;
		if (arguments.length < _BASICARGS)	//Check for basic parameters
			throw ("Wrong number of parameters to ajaxXml function");
        
	  $.ajax({
    	url: httplistenerurl,
    	contentType: 'text/xml',
		async: false,
    	type: 'POST',
    	dataType: 'xml',
    	timeout: 30000,
    	data: inXml,
    	error: this._onError,
    	success: this._onSuccessXml,
    	mySuccess: successFunction,
    	myErrorFunction: errorFunction,
    	myPassThrough: passThrough
		});
	},
	
	json: function(busyDivSelector, url, dataIn, callback)
	{
		// START Google Analytics CODE
		var startIndex = url.indexOf("?ajax=");
		var endIndex = url.indexOf("&");		
		var category = url;
		
		if (startIndex == endIndex){
			endIndex = -1;
		}
		if (startIndex != -1){
			if (endIndex != '-1'){
				category = url.substring(startIndex+6, endIndex);			        	
			} else {
				category = url.substring(startIndex+6);
			} 
		}
		
		// Set action
		var action = "load";
		if (category.indexOf("reset") != -1){
			action = "reset";
		} else 	if (category.indexOf("print") != -1){
			action = "print";
		} else 	if (category.indexOf("create") != -1){
			action = "create";
		} else 	if (category.indexOf("validate") != -1){
			action = "validate";
		} else 	if (category.indexOf("lock") != -1){
			action = "lock";
		}
 
		gtag('event', action, {
			  'event_category' : category
		}); // END Google Analytics CODE
		
		var provajaxobj = this;
		provajaxobj._init();
		if (busyDivSelector) {
			provajaxobj._initBlockui(function(){
				provcommon.blockUI(busyDivSelector);
			});
		}
		
		$.getJSON(url, dataIn, function(data)
			{
				if (data.provenirError) {
					alert("Error: " + data.provenirError);
				} else {
					callback(data);
				}
				if (busyDivSelector)
					try{
						$(busyDivSelector).unblock();	
					}catch(e){
					}
	    	});
	},
	
	ajax: function(busyDivSelector, url, requestType, xmlData, callback)
	{
		var provajaxobj = this;
		provajaxobj._init();
		if (busyDivSelector) {
			provajaxobj._initBlockui(function(){
				provcommon.blockUI(busyDivSelector);
			});
		}
		
		if (!requestType) requestType = "POST";
		$.ajax({
	    	url: url,
	    	contentType: 'text/xml',
	    	type: requestType,
	    	dataType: 'xml',
	    	timeout: 30000,
	    	data: xmlData,
	    	success: function(xml)
	    	{
				callback(xml);
				if (busyDivSelector)
					try{
						$(busyDivSelector).unblock();	
					}catch(e){
					}
	    	}
		});
	},
	
	get: function(busyDivSelector, url, showBusy, callback)
	{
		var provajaxobj = this;
		provajaxobj._init();
		if (showBusy == true) {
			provajaxobj._initBlockui(function(){
				provcommon.blockUI(busyDivSelector);
			});
		}
		
		$.get(url, 
			function(data){ 
				callback(data);
				if (showBusy == true)
					try{
						$(busyDivSelector).unblock();	
					}catch(e){
					}
			}
		);	    
	},
	
	//Does a load, but supports submitType of "GET" or "POST"
	loadFromUrl: function(divObj, url, submitType, callback) {
		this._init();
		
		var params = null;
		
		if (submitType.toLowerCase() == "post") {
			//Parse parameters
			params = {};
			if (url.contains("?")) {
				var paramsTxt = url.substring(url.indexOf("?") + 1);
				url = url.substring(0, url.indexOf("?"));
				var paramsSplit = paramsTxt.split("&");
				for (var idx in paramsSplit) {
					var paramTxt = paramsSplit[idx];
					var paramName = paramTxt;
					var paramVal = "";
					if (paramTxt.contains("=")) {
						var paramSplit = paramTxt.split("=");
						paramName = paramSplit[0];
						paramVal = paramSplit[1];
					};					
					params[paramName] = paramVal;
				}
			}
		}
		
		divObj.load(url,
				params,
				function (responseText, textStatus, req) {
					if (callback) callback();
	        	}
		);
	},
	
	load: function(divSelector, busyDivSelector, url, callback, callbackdata)
	{		
		var provajaxobj = this;
		provajaxobj._init();
		if (busyDivSelector) {
			provajaxobj._initBlockui(function(){
				provcommon.blockUI(busyDivSelector);
			});
		}
		
		/* Google Analytics Event Tracking snippet. PROV-1238 */
		var startIndex = url.indexOf("&to=") == -1 ? url.indexOf("?to=") : url.indexOf("&to=");
		var endIndex = url.indexOf("&");
		
		if (startIndex == endIndex){
			endIndex = -1;
		}
		var category = url;
		if (startIndex != -1){
			if (endIndex != '-1'){
				category = url.substring(startIndex+4, endIndex);			        	
			} else {
				category = url.substring(startIndex+4);
			} 
		}
		gtag('event', 'load', {
			  'event_category' : category,
		}); //END Google Analytics
		
		$(divSelector).load(url, 		    
				function (responseText, textStatus, req) {
					var pattern = /<!--ProvInit=(.*?)-->/m ;
					var match = pattern.exec(responseText);
					if (match != null) {
						var name = match[1];
						provcommon.runFunction(name);
					}
					
   					provcsrf.insertPageTokens();
					if (busyDivSelector){
						try{
							$(busyDivSelector).unblock();
						}catch(e){
						}
					}
					if (callback) callback(callbackdata);
					
					
					
	        	}
		);
	},
	
	submitAndLoad : function(divSelector, busyDivSelector, formSelector, callback)
	{
		var formName = formSelector;
		if (typeof formName === 'string') {
			formName = $(formName + " input[name=to]").val();
			if (formName === "" || formName === undefined){
				formName = formSelector.substring(1);
			}
		} else if (formName instanceof Object) {
			formName = formName.find("input[name=to]").attr("value");
		} 
		gtag('event', 'save', {
				  'event_category' : formName
		}); // END Google Analytics CODE
		   
		var provajaxobj = this;
		provajaxobj._init();
		provajaxobj._initBlockui(function(){
			provajaxobj._initJqueryForm(function() {
				provcommon.blockUI(busyDivSelector);
		        $(formSelector).ajaxSubmit({
		        	target: divSelector,
		        	success: function() {
       					provcsrf.insertPageTokens();
		        		try {
		        			if ($(busyDivSelector) != null) {
		        				$(busyDivSelector).unblock();	
		        			}
		        		} catch(e) {}
       					if (callback) { 
       						callback();
       					}
		        	}
		        });
		        
		       

			});
		});
	},
	
	submitAndLoadPromise: function(divSelector, busyDivSelector, formSelector, callback) {
		return new Promise(function(resolve, reject) {
			provajax.submitAndLoad(divSelector, busyDivSelector, formSelector, function cb() {
				if (callback) { callback(); }
				resolve();
			});
		});
	},	
		
	loadCsrf : function(csrfurl)
	{
		provcsrf.init(csrfurl);
	},
	
	//--------------------------------------------------------------------------------
	//Internal code
	//--------------------------------------------------------------------------------
	_initBlockui : function(callback) {
		if ($(document).data("provAjaxBlockUiInitialized")) { 
			callback();
			return;
		}

		$.ajax({
			  url: "jscompressed/provenir/base/common/js/jquery.blockUI.js",
			  dataType: 'script',
			  async: false,
			  success: callback
			});
		$(document).data("provAjaxBlockUiInitialized", true);
	},
	
	_initJqueryForm : function(callback) {
		if ($(document).data("provAjaxJqueryFormInitialized")) { 
			callback();
			return;
		}
		$.ajax({
			  url: "jscompressed/provenir/base/common/js/jquery.form.js",
			  dataType: 'script',
			  async: false,
			  success: callback
			});
		$(document).data("provAjaxJqueryFormInitialized", true);
	},
	
	_init : function()
	{
		if ($(document).data("provAjaxInitialized")) return;
		if (provajax.message404 == null)
		{
			provajax.message404 = 'Requested URL not found.';
		}
		if (provajax.message0 == null)
		{
			provajax.message0 = 'There was an unexpected error, please contact Support.';
		}
		if (provajax.message500 == null)
		{
			provajax.message500 = 'Internal Server Error.';
		}
		if (provajax.messageParseError == null)
		{
			provajax.messageParseError = 'Error.\nParsing JSON Request failed.';
		}
		if (provajax.messageTimeout == null)
		{
			provajax.messageTimeout = 'Request Time out.';
		}
		if (provajax.messageUnknownError == null)
		{
			provajax.messageUnknownError = "Unknown Error";
		}

		
		//Load required JS files	
		$.ajax({
			  url: "jscompressed/provenir/base/common/js/provcommon.js",
			  dataType: 'script',
			  async: false
			});

		$.ajaxSetup({
			cache: false,
			beforeSend : function(xhr) {
				if (provcsrf.csrfJson != null) {
					xhr.setRequestHeader(provcsrf.csrfJson.token_name, provcsrf.csrfJson.token_value);
				}
			},
			error:function(x,e){
				if(x.status==0){
					alert(provajax.message0);
				}else if(x.status==404){
					alert(provajax.message404);
				}else if(x.status==500){
					alert(provajax.message500 + x.responseText);
				}else if(e=='parsererror'){
					alert(provajax.messageParseError);
				}else if(e=='timeout'){
					alert(provajax.messageTimeout);
				}else {
					alert(provajax.messageUnknownError + '\n' + x.responseText);
				}
			}
		});
		$(document).data("provAjaxInitialized", true);
	},

	_onError: function(XMLHttpRequest, textStatus, errorThrown)
	{
		var msg = textStatus;
		if (msg == "error") 
			msg  = "Could not connect to server";
		if (this.myErrorFunction != null)
		{
			this.myErrorFunction(msg, this.myPassThrough);
		}
		else
			alert('Error making AJAX call:' + msg);
	},
	
	_xmlRequestParams: function(callFunctionName, args, argStart)
	{
		var req = "<Provenir><Request><CustData><AJAXIN><" + callFunctionName + " ";
		for(var i=argStart-1; i<args.length; i++)
		{
			req += " " + args[i] + "='" + args[i+1].replace(/\'/g, "\'") + "'" ;
			i++;
		}				
		req += "/></AJAXIN></CustData></Request></Provenir>";
		return req;
	},
	
	_checkForProvenirError: function(xml, dollarThis, msg)
	{
		var err = false;
		$(xml).find('ProvenirError').each(
    	function(){
      	err = true;
        alert(msg + ": " + $(this).text());
      }
    );
    return err;
	},
	
	_onSuccessParams : function(xml)
	{
		//Look for ProvenirErrors
    var err = provajax._checkForProvenirError(xml, 'Error making call to ' + this.myCallFunctionName);
        
		if (!err)
			this.mySuccess(xml, this.myPassThrough);
	},
	
	_onSuccessXml : function(xml)
	{
		//Look for ProvenirErrors
		var err = provajax._checkForProvenirError(xml, $(this), 'Error making call');     
		if (!err)
			this.mySuccess(xml, this.myPassThrough);
	}

};
	
provcsrf={
	csrfJson : null,
	
	init: function (csrfurl) {
		if (csrfurl != null) {

			$.ajax({
				  url: csrfurl,
				  dataType: 'json',
				  async: false,
				  cache: false,
				  success: function(data){
					provcsrf.csrfJson = data;
					if (provcsrf.csrfJson != null) {
						provcsrf.insertPageTokens();
					}
				  },
				  error: function(jqXHR, textStatus, errorThrown) {
				  },
				  complete: function() {
					  //alert("complete");
				  }
				});
			
//			$.getJSON(csrfurl, function(data){
//				csrfJson = data;
//				if (csrfJson != null) {
//					provcsrf.insertPageTokens();
//				}
//			});
		}
	},
	
	insertPageTokens: function () {
		/**
		 * Only inject the tokens if the JavaScript was referenced from HTML that
		 * was served by us. Otherwise, the code was referenced from malicious HTML
		 * which may be trying to steal tokens using JavaScript hijacking
		 * techniques.
		 */
		if(provcsrf.csrfJson != null && provcsrf.isValidDomain(document.domain, provcsrf.csrfJson.domain_origin)) {		
			provcsrf.injectTokens(provcsrf.csrfJson.token_name, provcsrf.csrfJson.token_value, {});
		}
	},
	
	/** check if valid domain based on domainStrict * */
	isValidDomain: function (current, target) {
		var result = false;
		
		/** check exact or subdomain match * */
		if(current == target) {
			result = true;
		} else if(provcsrf.csrfJson.domain_strict == false) {
			if(target.charAt(0) == '.') {
				result = current.endsWith(target);
			} else {
				result = current.endsWith('.' + target);
			}
		}
		
		return result;
	},

	/** determine if uri/url points to valid domain * */
	isValidUrl: function (src) {
		var result = false;
		/** parse out domain to make sure it points to our own * */
		if(src.substring(0, 7) == "http://" || src.substring(0, 8) == "https://") {
			var token = "://";
			var index = src.indexOf(token);
			var part = src.substring(index + token.length);
			var domain = "";
			
			/** parse up to end, first slash, or anchor * */
			for(i=0; i<part.length; i++) {
				var character = part.charAt(i);
				
				if(character == '/' || character == ':' || character == '#') {
					break;
				} else {
					domain += character;
				}
			}
			
			result = provcsrf.isValidDomain(document.domain, domain);
			/** explicitly skip anchors * */
		} else if(src.charAt(0) == '#') {
			result = false;
			/** ensure it is a local resource without a protocol * */
		} else if(!src.startsWith("//") && (src.charAt(0) == '/' || src.indexOf(':') == -1)) {
			result = true;
		}
		
		return result;
	},

	/** parse uri from url * */
	parseUri: function (url) {
		var uri = "";
		var token = "://";
		var index = url.indexOf(token);
		var part = "";
		
		/**
		 * ensure to skip protocol and prepend context path for non-qualified
		 * resources (ex: "protect.html" vs
		 * "/Owasp.CsrfGuard.Test/protect.html").
		 */
		if(index > 0) {
			part = url.substring(index + token.length);
		} else if(url.charAt(0) != '/') {
			if (provcsrf.csrfJson != null)
				part = provcsrf.csrfJson.context_path + url;
			else part = url;
		} else {
			part = url;
		}
		
		/** parse up to end or query string * */
		var uriContext = (index == -1);
		
		for(var i=0; i<part.length; i++) {
			var character = part.charAt(i);
			
			if(character == '/') {
				uriContext = true;
			} else if(uriContext == true && (character == '?' || character == '#')) {
				uriContext = false;
				break;
			}
			
			if(uriContext == true) {
				uri += character;
			}
		}
		
		return uri;
	},

	/** inject tokens as hidden fields into forms * */
	injectTokenForm: function (form, tokenName, tokenValue, pageTokens) {
		var action = form.getAttribute("action");
		var enctype = form.getAttribute("enctype");
		if (enctype != null && enctype.toLowerCase() == "multipart/form-data") {
			provcsrf.injectTokenAttribute(form, "action", tokenName, tokenValue, pageTokens);
		} else if(action != null && typeof action == "string" && provcsrf.isValidUrl(action)) {
			var csrf = form.elements[tokenName];
			if (csrf == null) {
				var uri = provcsrf.parseUri(action);
				var hidden = document.createElement("input");
			
				hidden.setAttribute("type", "hidden");
				hidden.setAttribute("name", tokenName);
				hidden.setAttribute("value", (pageTokens[uri] != null ? pageTokens[uri] : tokenValue));
			
				form.appendChild(hidden);
			}
		} else if (action != null && typeof action == "object") {
			//041811alert("object action: " );
		}
	},

	/** inject tokens as query string parameters into url * */
	injectTokenAttribute: function (element, attr, tokenName, tokenValue, pageTokens) {
		if (element.nodeName.toLowerCase() == 'iframe' && attr == "src" && element.getAttribute(attr).length == 0) {
			//alert("found an iframe with empty src!");
			return;
		}
		if (attr == "src" && (element.nodeName.toLowerCase() == "img" || element.nodeName.toLowerCase() == "script")) {
			return;
		}
		if (attr == "href" && (element.nodeName.toLowerCase() == "link")) {
			return;
		}
		var location = element.getAttribute(attr);
		if(location != null && provcsrf.isValidUrl(location)) {
			var uri = provcsrf.parseUri(location);
			var value = (pageTokens[uri] != null ? pageTokens[uri] : tokenValue);
			
			var csrf = tokenName + '=' + value;
			if (location.indexOf(csrf) == -1) {
				if(location.indexOf('?') != -1) {
					location = location + '&' + csrf;
				}  else {
					location = location + '?' + csrf;
				}
			}
			try {
				element.setAttribute(attr, location);
			} catch (e) {
				// attempted to set/update unsupported attribute
			}
		}
	},

	/** inject csrf prevention tokens throughout dom * */
	injectTokens: function (tokenName, tokenValue, pageTokens) {
		/** iterate over all elements and injection token * */
		var all = document.all ? document.all : document.getElementsByTagName('*');
		var len = all.length;

		for(var i=0; i<len; i++) {
			var element = all[i];
			
			/** inject into form * */
			if(element.tagName.toLowerCase() == "form") {
				if(provcsrf.csrfJson.inject_forms == true) {
					provcsrf.injectTokenForm(element, tokenName, tokenValue, pageTokens);
				}
				/** inject into attribute * */
			} else if(provcsrf.csrfJson.inject_attributes == true) {
				provcsrf.injectTokenAttribute(element, "src", tokenName, tokenValue, pageTokens);
				provcsrf.injectTokenAttribute(element, "href", tokenName, tokenValue, pageTokens);
			}
		}
	},
	
	addTokenToString : function(url) {
		if (provcsrf.csrfJson != null) {
			 var csrf = provcsrf.csrfJson.token_name + '=' + provcsrf.csrfJson.token_value;
			 if (url.indexOf(csrf) == -1) {
				 if(url.indexOf('?') != -1) {
					 url = url + '&' + csrf;
				 } else {
					 url = url + '?' + csrf;
				 }
			 }
		 }
		 return url;
	}
};

$().ready(function(){
	provajax._init();
});